export default "__VITE_ASSET__CvbDx0tR__"